import { useEffect, useState } from "react";
import { Add_cart,Sub_cart, Trash } from "../../../../../../assets/icons";
import "./style.css"
import useAppAccessor from "../../../../../../hooks/useappAccessor";
import useAppDispatch from "../../../../../../hooks/useAppDispatch";
import { setProductsInCart } from "../../../../../../modules/interactions/interaction.actions";
import { addCurrencyFormat } from "../../../../../../utils/currency.util";
const decimalComponent = (number: any) => {
  if (number == undefined) return;

  if (
    typeof number === "string" &&
    !number.includes(".") &&
    !number.includes("-") &&
    !number.includes(",")
  ) {
    number = addCurrencyFormat(number)
  }

  if (number.includes("-")) {
    const numb1: any = number.toString().split("-")[0];
    const numb2: any = number.toString().split("-")[1];
    // Add .00 to round numbers in range
    const [integerPart, decimalPart] = numb1.toString().includes(".")
      ? numb1.toString().split(".")
      : [numb1.toString(), "00"];
    const [integerPart_2, decimalPart_2] = numb2.toString().includes(".")
      ? numb2.toString().split(".")
      : [numb2.toString(), "00"];

    return (
      <div className="flex items-center justify-center">
        <div
          className="text-base"
          style={{ position: "relative", marginRight: 15 }}
        >
          {`${integerPart}.`}
          <span
            className="text-[10px] font-semibold"
            style={{ position: "absolute", bottom: 3 }}
          >{`${decimalPart}`}</span>
        </div>
        -
        <div
          className="text-base"
          style={{ position: "relative", marginRight: 15, marginLeft: 5 }}
        >
          {`${integerPart_2}.`}
          <span
            className="text-[10px] font-semibold"
            style={{ position: "absolute", bottom: 3 }}
          >{`${decimalPart_2}`}</span>
        </div>
      </div>
    );
  } else if (number.includes(",")) {
    // Handle comma-separated numbers
    const [integerPart_3, decimalPart_3] = number.toString().includes(",")
      ? number.toString().split(",")
      : [number.toString(), "00"];
    return (
      <div className="flex items-center justify-center">
        <div
          className="text-base"
          style={{ position: "relative", marginRight: 15 }}
        >
          {`${integerPart_3},`}
          <span
            className="text-[10px] font-semibold"
            style={{ position: "absolute", bottom: 3 }}
          >{`${decimalPart_3}`}</span>
        </div>
      </div>
    );
  } else {
    // Handle regular numbers
    var [integerPart_3, decimalPart_3] = number.toString().includes(".")
      ? number.toString().split(".")
      : [number.toString(), "00"];
    if (decimalPart_3?.includes(" ")) {
      decimalPart_3 = decimalPart_3.split(" ")[0];
    }
    return (
      <div className="flex items-center justify-center">
        <div
          className="text-base"
          style={{ position: "relative", marginRight: 15 }}
        >
          {`${integerPart_3}.`}
          <span
            className="text-[10px] font-semibold"
            style={{ position: "absolute", bottom: 3 }}
          >{`${decimalPart_3}`}</span>
        </div>
      </div>
    );
  }
};


const CartListView=(props:any)=>{
  const {getInteractions, } = useAppAccessor()
  const {productDetail, productsInCart} = getInteractions();
  const dispatch = useAppDispatch();

    useEffect(()=>{
     // console.log("productsInCart in redux====>Main",productsInCart)
    },[productsInCart])
    

    const handleQtyOnclick=(isIncrease:any, data: any)=>{
     // console.log(data);
     // console.log(productsInCart);
      let cartProducts = productsInCart;
      cartProducts = cartProducts.map((item:any) => {
        if(data.sku === item?.sku) {
          if (item.quantity === 1 && !isIncrease) {
            return {
              ...item,
              quantity: -1
            };
          }
          if (item.quantity === item.maxQty && isIncrease) {
            return {
              ...item,
              quantity: item.maxQty
            };
          }
          return {
            ...item,
            quantity: isIncrease ? item.quantity + 1 : item.quantity - 1 >= 0 ? item.quantity - 1 : 0
          }
        }
        return item;
      })
        cartProducts = cartProducts.filter((item:any) => item.quantity != -1);

        dispatch(setProductsInCart(cartProducts));
      }
      

    return(
        <div style={{height:document.getElementById('iFrameContainer')?.offsetHeight}}>
            {
               productsInCart.map((data:any,index:any)=>{
                   return(
                <div key={`cart-item-${data.sku}-${index}`} className="flex w-full pl-4 pr-4 pt-4 pb-4 border border-[#D8D8D8] bg-white">
                  <div className="image mr-4 w-[15%]">
                    <img src={data.imageUrl} className="w-full h-full object-contain"></img>
                  </div>
                  <div className="flex flex-col justify-between w-[85%]">
                    <span className="text-base txt-black font-semibold mb-2">
                      <div dangerouslySetInnerHTML={{ __html: data.name }} />  
                    </span>
                    <div className="flex items-center justify-between">
                      <div className="min-w-[80px] border border-[#979797] rounded-md px-3 py-1.5 bg-white">
                        <div className="flex items-center">
                          <span className="text-lg text-gray-800 ml-[1px]">
                            {decimalComponent(data.priceString)}
                          </span>
                        </div>
                      </div>
                      <div className="flex items-center gap-2 sm:gap-3">
                        <div className="flex items-center border border-[#979797] rounded-md w-[120px] sm:w-[140px]" style={{height:36}}>
                          <button 
                            onClick={()=>{handleQtyOnclick(false, data)}}
                            className="w-8 sm:w-10 h-full flex items-center justify-center border-r border-[#979797] hover:bg-gray-50"
                          >
                            {data.quantity == 0 ? (
                              <img src={Trash} className="w-3 sm:w-4 h-3 sm:h-4" alt="Remove" />
                            ) : (
                              <img src={Sub_cart} className="w-3 sm:w-4 h-3 sm:h-4" alt="Decrease" />
                            )}
                          </button>
                          <div className="flex-1 h-full flex items-center justify-center text-sm sm:text-base font-medium">
                            {data.quantity}
                          </div>
                          <button 
                            onClick={()=>{handleQtyOnclick(true, data)}}
                            className="w-8 sm:w-10 h-full flex items-center justify-center border-l border-[#979797] hover:bg-gray-50"
                          >
                            <img src={Add_cart} className="w-3 sm:w-4 h-3 sm:h-4" alt="Increase" />
                          </button>
                        </div>
                        <button 
                          onClick={() => {
                            const cartProducts = productsInCart.map((item:any) => 
                              item.sku === data.sku ? {...item, quantity: -1} : item
                            ).filter((item:any) => item.quantity !== -1);
                            dispatch(setProductsInCart(cartProducts));
                          }}
                          className="flex items-center justify-center border border-[#979797] rounded-md w-8 sm:w-10 h-9 hover:bg-gray-50"
                        >
                          <img src={Trash} className="w-3 sm:w-4 h-3 sm:h-4" alt="Remove item" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>)
                  }) 
            }

              {
                props.checkoutElem
              }
           
        </div>
    )

}

export default CartListView;